import { Text } from "core-library/Text/Text";

interface ErrorProps {
  text: string;
}
export const Error = ({ text }: ErrorProps) => {
  return <Text variant="inputHint" color="error" />;
};
